/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_0_Figure_CaptionInputs */

const en_gc_search_guides_gridcraft_online_sections_0_figure_caption = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_0_Figure_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The launch screen lets you choose a sample before starting. Captured on gridcraft.me’s local preview, November 2026.`)
};

const zh_gc_search_guides_gridcraft_online_sections_0_figure_caption = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_0_Figure_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动页面可在运行前选择示例。截图来自 gridcraft.me 本地预览，2026 年 11 月。`)
};

/**
* | output |
* | --- |
* | "The launch screen lets you choose a sample before starting. Captured on gridcraft.me’s local preview, November 2026." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_0_Figure_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_0_figure_caption = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_0_Figure_CaptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_0_Figure_CaptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_0_figure_caption(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_0_figure_caption(inputs)
});
export { gc_search_guides_gridcraft_online_sections_0_figure_caption as "gc.search_guides.gridcraft_online.sections.0.figure.caption" }